<div #controlContainer class="container">
  <label [for]="placeholder" class="input-label">{{
    placeholder + "" | translate
  }}</label>
  <input
    class="input"
    type="text"
    [type]="this.showPassword ? 'text' : 'password'"
    [id]="this.placeholder"
    [formControl]="this.passwordControl"
  />
  <figure
    (click)="this.showHidePassword()"
    [id]="!this.placeholder ? 'password' : this.placeholder"
    class="show-password"
  >
    <img
      [id]="!this.placeholder ? 'password' : this.placeholder"
      [src]="
        'svgs/form-controls/' +
        (this.showPassword ? 'show' : 'hide') +
        '-password.svg'
      "
      [alt]="('login.form.password' | translate) + ' icon'"
    />
  </figure>
</div>
<app-validation-hint
  [controlContainer]="controlContainer"
  [textControl]="this.passwordControl"
  [translationName]="'login.form.password' | translate"
></app-validation-hint>
